import { DetailsSelection, DetailsTabType } from "../JobDetails";
import DetailsPanel from "./DetailsPanel";
import LogsPanel from "./LogsPanel";
import MappedTasksPanel from "./MappedTasksPanel";

interface TabPanelProps {
    children?: React.ReactNode;
    name: string;
    value: string;
  }
  
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, name, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== name}
        id={`simple-tabpanel-${name}`}
        aria-labelledby={`simple-tab-${name}`}
        className="w-full max-w-full grow min-h-0 overflow-y-auto"
        {...other}
      >
        {value === name && <>{children}</>}
      </div>
    );
  }

const displayLogs = (selection: DetailsSelection) => {
  let showLogs = false;
  if (selection.logs) {
      const logs = selection.logs;

      if (logs.return_value && typeof logs.return_value === 'string') {
        showLogs = true;
      } else if (logs.result) {
        const result = logs.result;

        if (result.docker_stderr_logs && typeof result.docker_stderr_logs === 'string') {
          showLogs = true;
        }
      }
  }

  return showLogs;
}

export default function DetailsTabPanels({
    tab,
    selection,
}: {
    tab: DetailsTabType,
    selection: DetailsSelection,
}) {

  

    return (
        <>
            <CustomTabPanel value={tab} name="details" >
                <DetailsPanel details={selection.details}/>
            </CustomTabPanel>
            {selection.metadata && (
                <CustomTabPanel value={tab} name='metadata'></CustomTabPanel>
            )}
            {selection.mapped_tasks && (
                <CustomTabPanel value={tab} name='mapped_tasks'>
                  <MappedTasksPanel mappedTasks={selection.mapped_tasks} />
                </CustomTabPanel>
            )}
             {displayLogs(selection) && (
                <CustomTabPanel value={tab} name='logs'>
                  <LogsPanel logs={selection.logs}/>
                </CustomTabPanel>
            )}
        </>
    )
}